module.exports = __webpack_public_path__ + "img/area_6.ca994935.png";